import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

const BASE_URL = `/room`;

const RoomService = {
    getListForAdmin: (params: any): Promise<AxiosResponse> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search
        };
        return instanceAxios.get(`${BASE_URL}/list-for-admin`, {
            params: queryParams,
        });
    },
};

export default RoomService;